// @flow
import type { Location } from '../../../models/location'
import type { StationLocation } from '../../../api_types'

// Utils
function buildVoyageStationLocation(loc: StationLocation): Location {
  return {
    name: loc.full_address || '',
    customName: '',
    address: loc.full_address || '', // important for `getMaximizedLocation`
    fullAddress: loc.formatted_address || loc.full_address || '',
    iataCode: '',
    country: '',
    notSpecific: false,
    timezone: '',
    placeId: '',
    airportName: '',
    trainStationName: '',
    isTrainStation: false,
    isCruisePort: false,
    type: 'place',
  }
}

export default buildVoyageStationLocation
